import { render, staticRenderFns } from "./index.vue?vue&type=template&id=235b5fc6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=235b5fc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b5fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235b5fc6')) {
      api.createRecord('235b5fc6', component.options)
    } else {
      api.reload('235b5fc6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=235b5fc6&scoped=true&", function () {
      api.rerender('235b5fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/department/compoments/Threshold/index.vue"
export default component.exports